export default {"src":"/_next/static/media/nintendo.fe0ca2c3.svg","height":46,"width":182};